export const getOptionsFilterSelector = store => store.instagram.filterInfo;
export const getOptionsSearchSelector = store => store.instagram.searchValue;
export const getOffsetInfo = store => store.instagram.offset;
export const instagramSelector = store => store.instagram;
